// PlantArrayActivityTablePage.jsx
import React, { useState, useEffect } from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import PlantArrayActivityLayer from "../components/PlantArrayActivityLayer";

const PlantArrayActivityTablePage = () => {
  const [ids, setIds] = useState([]);

  // You can fetch IDs from an API, context, or other source
  useEffect(() => {
    // Example: Get IDs from localStorage, context, or API
    const storedIds = JSON.parse(localStorage.getItem('selectedPlantationIds') || '[]');
    setIds(storedIds);
  }, []);

  return (
    <MasterLayout>
      <Breadcrumb 
        title="Specific Activities" 
        tooltipContent="Add New Complaint" 
        linkTo="/complains/add"  
        requiredPermission={{ module: 'complaints', action: 'create' }}
      />
      <PlantArrayActivityLayer ids={ids} />
    </MasterLayout>
  );
};

export default PlantArrayActivityTablePage;